import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A CMS must always show current state. With a stale window, a list
      // revisited inside it renders from cache — so a record deleted in another
      // tab, or by another editor, keeps appearing. Refetching on mount and on
      // focus costs one request and removes a whole class of "my change is not
      // showing" confusion.
      staleTime: 0,
      refetchOnMount: "always",
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
